import React from "react";

const PrivacyPolicy = () => (
  <div className="max-w-3xl mx-auto py-12 px-4 md:px-6 lg:px-8">
    <h1 className="text-4xl font-bold text-primary mb-8">Privacy Policy</h1>
    <p className="text-gray-700 mb-6">
      Your privacy is important to us. This policy explains how{" "}
      <strong>ThoughtCode</strong> will not collects, uses your information.
    </p>

    <div className="border-t border-gray-200 pt-6 mt-6">
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">
        Information We Collect
      </h2>
      <ul className="list-disc list-inside text-gray-700 space-y-2">
        <li>Personal information you provide (name, email, etc.)</li>
        <li>Resume data you enter</li>
        <li>Usage data (pages visited, actions taken)</li>
      </ul>
    </div>

    <div className="border-t border-gray-200 pt-6 mt-6">
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">
        How We Use Your Information
      </h2>
      <ul className="list-disc list-inside text-gray-700 space-y-2">
        <li>To provide and improve our services</li>
        <li>To personalize your experience</li>
        <li>To communicate with you</li>
      </ul>
    </div>

    <div className="border-t border-gray-200 pt-6 mt-6">
      <h2 className="text-2xl font-semibold text-gray-900 mb-4">Your Rights</h2>
      <p className="text-gray-700">
        You can request to view, update, or delete your personal data at any
        time by contacting our support team.
      </p>
    </div>

    <p className="text-sm text-gray-500 mt-10 italic">
      Last updated: {new Date().toLocaleDateString()}
    </p>
  </div>
);

export default PrivacyPolicy;
